import 'toastr/toastr.scss'
import toastr from 'toastr'

const settings = require('../../common.json')
const nJsonData = require('../../models-detail.json')
settings.messages = $.extend({}, settings.messages, nJsonData.messages)

export const modelsDetailPage = {
  thumbing: false,

  thumbLoading ($m, i = true) {
    if (i) {
      $m.stop(true, true).animate({ opacity: 0.5 }, settings.animation.duration).prop('disabled', true)
    } else {
      $m.stop(true, true).animate({ opacity: 1 }, settings.animation.duration).prop('disabled', false)
    }
  },

  thumb ($model) {
    const _this = this
    if (!_this.thumbing) {
      const backupHtml = $model.html()
      _this.thumbing = true
      $model.html('veuillez patienter...')
      _this.thumbLoading($model)
      toastr.remove()
      toastr.info(settings.messages.vote.voting, '', { closeButton: false, timeOut: 50000 })
      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: document.location.origin + '/plans-maisons/thumb',
        data: { model: $model.attr('data-model') },
        success (response) {
          if (response.error === 0) {
            toastr.remove()
            toastr.success(settings.messages.vote.successVote)
          } else {
            toastr.remove()
            toastr.warning(settings.messages.vote.alreadyVoted)
          }
        },
        error () {
          toastr.remove()
          toastr.error(settings.messages.errors.retry)
        },
        complete () {
          _this.thumbing = false
          $model.html(backupHtml)
          _this.thumbLoading($model, false)
        }
      })
    }
  },

  init () {
    const _this = this
    $('#like-model').on('click', function () { // bouton j'aime
      _this.thumb($(this))
    })
    $('#track-financing').on('click', function () { // event sur bouton financement : track event google analytics
      /* global ga */
      if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Financement modele', 'Clic') }
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'financing', { element: 'model' }) }
    })
    $('#track-contact').on('click', function () { // event sur bouton contact : track event google analytics
      if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Contacter modele', 'Clic') }
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact', { subject: 'model' }) }
    })
    $('#track-ground').on('click', function () { // event sur bouton terrain
      if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Recherche terrain', 'Clic') }
      if (typeof (googletag) !== 'undefined') { gtag('event', 'find_ground') }
    })
    // scroll pour les ancres de page
    $('.go').on('click', function () {
      const t = $(this).attr('target')
      $('html, body').animate({
        scrollTop: ($(t).offset().top - $('#navigation4').height())
      }, 500)
    })
  }

}
